import { AutogenModelEdiOrder, AutogenRowEdiOrder } from "./autogen/AutogenModelEdiOrder";

export class ModelEdiOrder extends AutogenModelEdiOrder<RowEdiOrder> {
    constructor() {
        super(RowEdiOrder);
    }
}

export class RowEdiOrder extends AutogenRowEdiOrder {
}